// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3 {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 15px;
  font-size: 18px;
  line-height: 27px;
  color: #00373D;
}

.container {
  display: flex;
  flex-direction: column;
  background-color: white;
  height: fit-content;
  padding-bottom: 10px;
}

.unassignActionPoint {
  margin: 15px auto 20px;
  color: #FF0000;
  font-size: 14px;
  line-height: 21px;
  background-color: transparent;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
